// Angular
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// Components
import { LoginComponent } from './login.component';

/**
 * Routes
 */
const routes: Routes = [
  {path: '', component: LoginComponent}
];

/**
 * Login Routing Module
 */
@NgModule({
  imports: [
    // Angular
    RouterModule.forChild(routes),
  ],
  exports: [
    // Angular
    RouterModule,
  ]
})
export class LoginRoutingModule {
}
